import {useTranslation, Trans} from '@/translations/i18n.tsx'
import {Container} from '@components/ui/container'
import {Helmet} from 'react-helmet'
import {Metrics} from '@features/insights/components/insights-metrics'
import {CommonIssues} from '@features/insights/components/common-issues'
import {useMemo} from 'react'
import {InsightsFilterParam, InsightsFiltersSelect} from '@features/insights/components/insights-filters-select'
import {useParsedSearchParams} from '@hooks/useParsedSearchParams'
import {useAuthStore} from '@features/user/store/store'
import {AirbnbGuidelinesModal} from '@features/insights/components/airbnb-guidelines-modal'
import {routes} from '@utilities/constants/routes'
import {Navigate} from 'react-router'
import {Spinner} from '@components/ui/spinner'
import {useMe} from '@features/user/queries/useMe'

export const Insights = () => {
    const {t} = useTranslation()
    const meQuery = useMe({throwOnError: true})
    const adminAccessToken = useAuthStore(state => state.adminAccessToken)
    const isInsightsVisible = meQuery.data?.isInsightsVisible || !!adminAccessToken
    const {searchParams} = useParsedSearchParams(InsightsFilterParam)
    const periodLabel = useMemo(() => {
        switch (searchParams.period) {
            case 'last_3_month':
                return t('insights:period_last_months', {count: 3})
            case 'last_6_month':
                return t('insights:period_last_months', {count: 6})
        }
    }, [searchParams.period, t])

    {
        /* TODO: remove this redirect when we have the feature @InsightsPage */
    }
    if (meQuery.isPending) return <Spinner size={40} />
    if (!isInsightsVisible) return <Navigate to={routes.HOME.handle.fullPath} />

    return (
        <div className="h-full [overflow:unset]">
            <Container className="grid grid-rows-[auto_1fr] gap-6 pt-4 pb-4 h-full md:h-auto md:gap-12 md:pt-16 md:pb-12">
                <div className="flex flex-col gap-6 md:gap-12">
                    <Helmet title={t('insights:meta_title')} />

                    <div className="flex justify-between flex-col items-start gap-6 w-full md:gap-2.5 md:flex-row md:items-center">
                        <div className="flex flex-col gap-2">
                            <h1 className="text-display-sm font-bold">{t('insights:title')}</h1>
                            <p className="text-sm text-neutral-700 md:text-lg">
                                <Trans
                                    i18nKey="insights:description"
                                    values={{period: periodLabel}}
                                    components={{
                                        br: <br />,
                                        guidelines: <AirbnbGuidelinesModal />
                                    }}
                                />
                            </p>
                        </div>

                        <InsightsFiltersSelect />
                    </div>
                </div>

                <div className="flex flex-col gap-6 md:gap-12 overflow-auto h-full [&>div]:w-full md:[overflow:unset]">
                    <Metrics isInsightsVisible={isInsightsVisible} />
                    <CommonIssues isInsightsVisible={isInsightsVisible} />
                </div>
            </Container>
        </div>
    )
}
